import React, { FC } from 'react';

import { Icon, sounds } from '@whitesharx/starfall-frontend-ui-kit';
import { containerStyles, iconContainerStyles } from './styles.css';

type GameLeaveToolProps = {
  onClick: () => void;
};

const GameLeaveTool: FC<GameLeaveToolProps> = ({ onClick }) => {
  const handleClick = () => {
    sounds.play('click');
    onClick();
  };

  return (
    <div className={containerStyles} onClick={handleClick}>
      <Icon name="logOut" size="18" className={iconContainerStyles} />
    </div>
  );
};

export default GameLeaveTool;
